import { ModalDialog } from 'components/ModalDialog';

interface IModalsCreateWorkOrderProps {
    isContractModalActive: boolean;
    isUnreadyModalActive: boolean;
    unreadyUerMsg: string;
    modalCancelHandler: () => void;
    modalContractConfirmHandler: () => void;
    modalUnreadyConfirmHandler: () => void;
}

export const ModalsCreateWorkOrder = ({
    isContractModalActive,
    isUnreadyModalActive,
    unreadyUerMsg,
    modalCancelHandler,
    modalContractConfirmHandler,
    modalUnreadyConfirmHandler,
}: IModalsCreateWorkOrderProps) => (
    <>
        <ModalDialog
            isOpen={isContractModalActive}
            title="Создание наряд-заказа"
            onClose={modalCancelHandler}
            onConfirm={modalContractConfirmHandler}
            withTitleCloseButton
            btnConfirmLabel="Заполнить"
            status="error"
            bodyMinHeight="min-content"
        >
            <div style={{ width: '460px', padding: '24px' }}>
                Заполните обязательные поля карточки Договора для создания Наряд-Заказа
            </div>
        </ModalDialog>

        <ModalDialog
            isOpen={isUnreadyModalActive}
            title="Создание наряд-заказа"
            onClose={modalCancelHandler}
            onConfirm={modalUnreadyConfirmHandler}
            withTitleCloseButton
            btnConfirmLabel="Заполнить"
            status="error"
            bodyMinHeight="min-content"
        >
            <div style={{ width: '460px', padding: '24px' }}>{unreadyUerMsg}</div>
        </ModalDialog>
    </>
);

ModalsCreateWorkOrder.displayName = 'ModalsCreateWorkOrder';
